// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DdjDocument } from '@interfaces/document.interfaces';

@Component({
    selector: 'app-document-status-modal',
    templateUrl: './document-status-modal.component.html',
    styleUrls: ['./document-status-modal.component.scss'],
})
export class DocumentStatusModalComponent {
    constructor(
        private dialogRef: MatDialogRef<DocumentStatusModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { document: DdjDocument; message: string }
    ) {}

    close() {
        this.dialogRef.close();
    }
}
